import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUtilQuantumMetricsModule } from '@domgen/dgx-fe-util-foundation';
import { WorldPayCardPaymentComponent } from './world-pay-card-payment.component';

@NgModule({
  declarations: [WorldPayCardPaymentComponent],
  exports: [WorldPayCardPaymentComponent],
  imports: [CommonModule, SharedUtilQuantumMetricsModule],
})
export class WorldPayCardPaymentModule {}
